import React from "react"
import SimpleText from "./simpleText"

import styles from "./sidebarList.module.scss"

const SidebarList = (props) => {
  const alt = props.alt ? { "data-alt": true } : null
  return (
    <ul className={styles.sidebarList} {...alt}>
      {props.tableRow.map(row => (
        <li key={row._key}>
          <p>
            <b>{row.rowTitle}</b>
          </p>
          <SimpleText blocks={row.rowValue} />
        </li>
      ))}
    </ul>
  )
}

export default SidebarList
